var _path, _circle, _path2, _path3, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTerraLight = function SvgTerraLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33c8.837 0 16-7.163 16-16S25.837 1 17 1 1 8.163 1 17s7.163 16 16 16Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.439,
    cy: 16.964,
    r: 9.61,
    fill: "#F2E373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.515 26.227c5 1.437 9.715-1.954 10.774-3.6-1.118.446-3.64.805-4.785-1.314s.405-4.083 1.323-4.8L7.666 17.704c.254 2.539 1.082 6.866 6.85 8.523Z",
    fill: "url(#terra_light_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m19.963 5.136.005-.011c.155-.345.25.033.258 1.034.008 1.25-1.267 2.272-2.698 2.94-2.5 1.167-3.288 3.933-2.064 5.215 2.59 2.715 4.744-.163 7.442-.326 1.92-.116 3.633 1.098 4.39 1.924.085.092-.004.228-.126.205-1-.192-2.958-.364-4.608.08-2.354.634-3.44 3.047-3.857 3.712-.331.529-2.97 4.31-7.351 2.88-4.382-1.431-4.474-7.208-2.281-10.72 2.236-3.583 7.438-4.955 9.099-5.474 1.318-.412 1.59-1.013 1.79-1.46Z",
    fill: "url(#terra_light_svg__b)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "#EEEEEF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "terra_light_svg__a",
    x1: 14.971,
    y1: 19.459,
    x2: 19.724,
    y2: 25.971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3C34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "terra_light_svg__b",
    x1: 10.451,
    y1: 10.151,
    x2: 18.762,
    y2: 20.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6CC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE3633"
  })))));
};
export default SvgTerraLight;